module.exports = __webpack_public_path__ + "assets/img/icon-8.f7c3329f.png";